export default __webpack_public_path__ + "static/media/logo_3d_no_text.d79a7133.png";